<template>
  <div style="background: #ffffff;">
    <quillEditor style="height: 387px"
                  v-model="content"
                  ref="myQuillEditor"
                  :options="editorOption"
                  @blur="onEditorBlur"
                  @focus="onEditorFocus"
                  @change="onEditorChange"></quillEditor>
    <el-upload
      style="display: none;"
      accept="image/*"
      :action="config.urlStr + '/index/Other/upload'"
      multiple
      :show-file-list="false"
      :before-upload="beforeUpload">
      <i class="btnbtn" ref="upload"></i>
    </el-upload>
  </div>
</template>

<script>
  import config from '../config/index'
  import { quillEditor } from 'vue-quill-editor'
  export default {
    data() {
      return {
        config: config,
        content: '',
        editorOption: {
          modules:{
            toolbar: {
              container: [
                // ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                [{ 'align': [] }],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                [{ 'indent': '+1' }],          // outdent/indent
                ['image'],
              ],
              handlers: {
                'image': function (value) {
                  if (value) {
                    // alert('自定义图片')
                    document.querySelector('.btnbtn').click()
                  } else {
                    this.quill.format('image', false)
                  }
                }
              }
            }
          },
          placeholder: '请输入'
        },
        titleConfig: {
          'ql-bold':'加粗',
          'ql-color':'颜色',
          'ql-font':'字体',
          'ql-code':'插入代码',
          'ql-italic':'斜体',
          'ql-link':'添加链接',
          'ql-background':'背景颜色',
          'ql-size':'字体大小',
          'ql-strike':'删除线',
          'ql-script':'上标/下标',
          'ql-underline':'下划线',
          'ql-blockquote':'引用',
          'ql-header':'标题',
          'ql-indent':'缩进',
          'ql-list':'列表',
          'ql-align':'文本对齐',
          'ql-direction':'文本方向',
          'ql-code-block':'代码块',
          'ql-formula':'公式',
          'ql-image':'图片',
          'ql-video':'视频',
          'ql-clean':'清除字体样式',
          'ql-upload':'文件'
        }
      }
    },
    props:{
      contents:{
        type: String,
        default: ''
      }
    },
    computed: {
      editor() {
        return this.$refs.myQuillEditor.quill
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        this.content = this.contents
        this.addQuillTitle()
      },
      onEditorBlur(){//失去焦点事件
      },
      onEditorFocus(){//获得焦点事件
      },
      onEditorChange(){//内容改变事件
        this.$emit('getData', this.content)
      },
      // 给各个选项设置一个title
      addQuillTitle () {
        const oToolBar = document.querySelector('.ql-toolbar'),
          aButton = oToolBar.querySelectorAll('button'),
          aSelect =  oToolBar.querySelectorAll('select')
        aButton.forEach((item) => {
          if(item.className === 'ql-script'){
            item.value === 'sub' ? item.title = '下标': item.title = '上标';
          }else if(item.className === 'ql-indent'){
            item.value === '+1' ? item.title ='向右缩进': item.title ='向左缩进';
          }else{
            item.title = this.titleConfig[item.classList[0]]
          }
        })
        aSelect.forEach((item) =>{
          item.parentNode.title = this.titleConfig[item.classList[0]];
        })
      },
      // 上传之前的验证
      beforeUpload (file) {
        var fd = new window.FormData();
        fd.append('image', file)
        fd.append('admin_id', this.$store.state.user.id)
        this.$api.apiContent.file(fd).then(res => {
          let url = res.data
          // 获取光标所在位置
          let length = this.editor.getSelection().index;
          // 插入图片，res为服务器返回的图片链接地址
          this.editor.insertEmbed(length, 'image', this.config.urlStr + '/' + url)
          // 调整光标到最后
          this.editor.setSelection(length + 1)
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
        return false
      }
    },
    components: {
      quillEditor
    },
    watch:{
      contents(){
        this.content = this.contents
      }
    }
  }
</script>

<style scoped lang="scss">
</style>